import { useParams } from 'react-router-dom';
import { Card } from 'antd';
import ajaxSeason from '../ajax/season';
import AddStage from '../components/AddStageAdvanced';


// import Season from './Season'; 
// const AjaxSeason = ajaxSeason(Season);

const AjaxAddStage = ajaxSeason(AddStage);

function RoutedAddStage() {
  const { id } = useParams();
  // console.warn('che id mi viene passato?', id);
  if (!id) return (<div></div>);
  return <AjaxAddStage id={id} />;
}

export default RoutedAddStage;